export default "__VITE_ASSET__BxlXrZw___"